import { FC } from 'react'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerText from '../../../components/custom_components/Text'
import { Select, Tabs } from 'antd'
import { DashboardSelectorValue } from '../dasboardStoreTypes'
import { useDashboardStore } from '../DashboardStore'
import { Country, PyramidType } from '../../../types'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'
import { CascaderOptionType } from 'antd/lib/cascader'
import { DashboardPyramidContent } from './DashboardPyramidsContent'

const { TabPane } = Tabs
const { Option } = Select

type DashboardPyramidsHeaderProps = {
  selectedCountry: DashboardSelectorValue
  onCountryChange: (country: Country) => void
  countriesForSelection: CascaderOptionType[]
}

const DashboardFiltersPyramidsHeader: FC<DashboardPyramidsHeaderProps> = ({ onCountryChange, selectedCountry, countriesForSelection }) => {
  const [t] = useTranslation()
  const multiCountry = countriesForSelection.length > 1

  return (
    <PerFlexRow noWrap width="fullWidth" justify="space-between" align="middle" className="dashboard-filters-area__pyramids__header">
      {multiCountry && (
        <Select
          className="dashboard-filters-area__pyramids__header__country-select"
          dropdownClassName="dashboard-filters-area__pyramids__country-select-dropdown"
          value={selectedCountry.value}
          onChange={(value) => onCountryChange(value as Country)}
          aria-label={t('dashboard.companyManager.header.companySelectAria')}
        >
          {countriesForSelection.map((c) => (
            <Option key={c.value} value={c.value}>
              {c.label}
            </Option>
          ))}
        </Select>
      )}
      <Tabs
        className="dashboard-filters-area__pyramids__header__tabs"
        activeKey={'level'}
        tabBarGutter={0}
        aria-label={t('dashboard.companyManager.filtersArea.pyramids.header.tabListAria')}
      >
        <TabPane
          key={'level'}
          tab={
            <PerText fontSize="s" color="secondary">
              {t('dashboard.companyManager.filtersArea.pyramids.level')}
            </PerText>
          }
        />
      </Tabs>
    </PerFlexRow>
  )
}

const DashboardPyramids: FC = () => {
  const [countriesForSelection, selectedCountry, setSelectedCountry] = useDashboardStore(
    (s) => [s.countriesForSelection, s.selectedCountry, s.setSelectedCountry],
    shallow,
  )
  return (
    <>
      <div className="dashboard-filters-area__pyramids">
        <DashboardFiltersPyramidsHeader
          onCountryChange={setSelectedCountry}
          selectedCountry={selectedCountry}
          countriesForSelection={countriesForSelection}
        />

        <div className="dashboard-filters-area__pyramids__content">
          <DashboardPyramidContent type={PyramidType.Level} />
        </div>
      </div>
    </>
  )
}

export default DashboardPyramids
